var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-auto"},[_c('ve-table',{attrs:{"max-height":"calc(100vh - 15.500rem)","scroll-width":"50rem","row-key-field-name":"id","columns":_vm.columns,"table-data":_vm.data,"border-around":false,"row-style-option":_vm.getRowStyleOption(),"expand-option":_vm.expandOption}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }